import React, { useEffect, useState } from 'react';
import { SendPostRequest } from '../../http';

const ClassicWhoWeAre = () => {
  const [homeIntroData, setHomeIntroData] = useState({});

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/aboutus");
    setHomeIntroData(response?.data);
  };
  return (
    <div className="section-about my-3">
      <div className="container">
        {/* Row */}

        {homeIntroData &&
          (homeIntroData?.who_we_are_video ||
            homeIntroData?.who_we_are_description) && (
            <div className="row d-flex align-items-center">
              {/* Col */}
              {/* <div className="col-lg-6 pad-md-bottom-30 "> */}
                  <div className="col-lg-6 col-md-12 col-12 pt-5 order-2 order-lg-1 classic-who-we-are">
                {homeIntroData?.who_we_are_video ? (
                  <div
                    className="about-vedio-frame w-100"
                    dangerouslySetInnerHTML={{
                      __html: homeIntroData?.who_we_are_video.replace(
                        /src=\"([^\"]+)\"/,
                        (match, p1) => {
                          const newUrl = new URL(p1);
                          newUrl.searchParams.set("autoplay", "1");
                          newUrl.searchParams.set("rel", "0");
                          newUrl.searchParams.set("mute", "1"); // ✅ Mute video
                          return `src=\"${newUrl.toString()}\"`;
                        }
                      ),
                    }}
                  />
                ) : homeIntroData?.image ? (
                  <div
                    style={{
                      height: "100%",
                      backgroundImage: `url(${homeIntroData?.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                ) : (
                  <div
                    style={{
                      height: "100%",
                      backgroundImage: `url("/assets/images/bg/bg-9.jpg")`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></div>
                )}
              </div>
              {/* .col */}
              {/* Col */}
              {/* <div className="col-lg-6"> */}
               <div className="col-lg-6 col-md-12 col-12 pt-5 order-1 order-lg-2">
                <div className="title-wrap margin-bottom-20">
                  <div className="section-title">
                    <div className="section-title margin-bottom-40">
                      <h2 className="title text-uppercase mb-0">
                        {homeIntroData?.who_we_are_heading || (
                          <>
                            Who We Are<span className="theme-color"></span>
                          </>
                        )}

                      </h2>
                      <span className="section-border-bottom"></span>
                    </div>
                  </div>
                  <div className="pad-top-5">
                    <p className="mb-0">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: homeIntroData?.who_we_are_description,
                        }}
                      ></span>
                    </p>
                  </div>
                </div>
              </div>
              {/* Col */}
            </div>
          )}
      </div>
      {/* Container */}
    </div>
  );
};

export default ClassicWhoWeAre;